import { FutureEntriesModalTranslations } from "./future-entries-modal-pt-br";

export const FUTURE_ENTRIES_MODAL_EN_US: FutureEntriesModalTranslations = {
	title: "Future Entries",
	search: "Search",
	return: "Return",
	totalEntries: "{{count}} entry",
	totalEntries_plural: "{{count}} entries",
	totalForMonth: "Total Entries",
	columns: {
		month: "Month",
		group: "GROUPING",
		total: "Total",
		type: "TYPE",
		category: "CATEGORY",
		originDestination: "ORIGIN/DESTINATION",
		observation: "OBSERVATION",
		competenceDate: "COMPETENCE DATE",
		liquidationDate: "SETTLEMENT DATE",
		value: "VALUE",
		totalReleases: "Total Entries",
		emptyText: "No future entries found",
	},
	excel: {
		title: "Future Entries - {{startDate}} to {{endDate}}",
		fileName: "future-entries-{{startDate}}-{{endDate}}",
	},
};
